// @ts-nocheck
import { createBrowserHistory, History } from '/data1/jenkins/workspace/aplus_tiger_my_level_20230614092632_tiger-platform_udb_my_level_115719_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';

let options = {
  "basename": "/h5/my_level/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
